import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import VacanciesList from '../../components/VacanciesList';
import BannersList from '../../components/BannersList';
import Select from '../../components/Select';
import CitySelect from '../../components/CitySelect';
import { withRouter } from 'react-router-dom';
import { setFilterData } from "../../actions/FiltersActions";
import { setCity, setCityPrepositional, setCityID, setCitySelected } from "../../actions/SetCity";
import { connect } from 'react-redux';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadScopeActivity } from '../../actions/ScopeActivityActions';
import { loadEmployments } from '../../actions/EmploymentsActions';
import { loadExperience } from '../../actions/ExperienceActions';
import { loadCities } from '../../actions/CitiesActions';
import { FormSubscribe } from '../../components/Form';
import queryString from 'query-string'
import Button from '../../components/Button';
import { HashLink as Link } from 'react-router-hash-link';
import scrollFunction from '../../utils/scroll';

const mappingScope = (array, newArray) => {
  if (array) {
    for (let i = 0; i < array.length; i++) {
      newArray[i] = {
        label: array[i].name,
        value: array[i].id,
        amount: array[i].vacancy_count,
        order: array[i].order,
        content: array[i].content
      }
    }
  }
}

class PageVacancies extends Component {
  static requestData(store) {
    return requestAll([loadVacancies, loadScopeActivity, loadEmployments, loadExperience, loadCities], store);
  }

  isNeedToFetchAllVacancies() {
    const isCityInQuery = Boolean(new URLSearchParams(this.props.location.search).get('city'));
    const isCoordsSavedInStorage = localStorage.getItem('coords') !== null;

    return !isCityInQuery && !isCoordsSavedInStorage
  }

  componentDidMount() {
    this.isNeedToFetchAllVacancies() && this.props.filter !== undefined &&
    // console.log('FFFFFFFF', this.props.filter);
    this.props.actions.loadVacancies(this.props.filter, true);
    this.props.actions.loadScopeActivity(this.props.filter);
    this.props.actions.loadEmployments(this.props.filter);
    this.props.actions.loadExperience(this.props.filter);
    // console.log(this.props);
    this.props.actions.loadCities().then(() => {
      if (this.props.location.search) {
        // parse URL
        const values = queryString.parse(this.props.location.search);
        // проверяем сферу из URL
        if (values.scope_activity && this.props.scope_activity && this.props.scope_activity.length > 0) {
          const scopeActivityQuery = parseInt(values.scope_activity, 10)
          let scopeActivityName = ''
          const scopeActivityList = this.props.scope_activity.filter(
            function(item) {
              return item.id === scopeActivityQuery;
            }
          );
          if (scopeActivityList.length > 0) {
            scopeActivityName = scopeActivityList[0].name;
          }
          this.props.handleLoad(scopeActivityQuery, scopeActivityName, 'scope_activity');
        }
        // проверяем город из URL
        if (values.city && this.props.cities) {
          const cityQuery = parseInt(values.city, 10)
          let cityName = ''
          let cityNamePrepositional = ''
          const citiesList = this.props.cities.filter(
            function(item) {
              return item.id === cityQuery;
            }
          );
          if (citiesList.length > 0) {
            cityName = citiesList[0].name;
            cityNamePrepositional = citiesList[0].name_prepositional || citiesList[0].name;
          }
          this.props.handleLoad(cityQuery, cityName, 'city', cityNamePrepositional);
          localStorage.getItem('coords') && this.props.actions.loadVacancies(this.props.filter, true);
        }
      }
    })
  }

  render() {
    const scope_activity = [];
    mappingScope(this.props.scope_activity, scope_activity);
    scope_activity.unshift({label: "Все сферы деятельности"});
    const employments = [];
    mappingScope(this.props.employments, employments);
    employments.unshift({label: "Любой тип занятости"});
    const experience = [];
    mappingScope(this.props.experience, experience);
    experience.unshift({label: "Любой опыт"});

    return (
      <div className="container container--indentVertical-xl">
        <Helmet>
          <title>Вакансии от работодателя — Трудоустройство и предложения о работе в ЭР-Телеком Холдинг</title>
          <meta name="description" content="Ищете работу? Ознакомьтесь с актуальными вакансиями в ЭР-Телеком Холдинг! Мы предлагаем карьерные возможности и официальное трудоустройство в телекоммуникационной компании ЭР-Телеком Холдинг. Найдите свою работу мечты на нашем сайте." />
        </Helmet>
        <CitySelect multiply={true} >Вакансии</CitySelect>
        <h1 className="text--hide">Вакансии в ЭР-Телеком</h1>
        <div className="row row--smallOffset row--marginBottom">
          <div className="col col--4 colTablet--12">
            <Select name="scopeActivity" value={{label: this.props.filter.scope_activity.label, id: this.props.filter.scope_activity.id}} options={scope_activity} placeholder="Все сферы деятельности" type="scope_activity" changeOption={this.props.handleChange} alphabeticSort={true} />
          </div>
          <div className="col col--4 colTablet--12">
            <Select name="employments" value={{label: this.props.filter.employment.label, id: this.props.filter.employment.id}} options={employments} placeholder="Любой тип занятости" type="employment" changeOption={this.props.handleChange} />
          </div>
          <div className="col col--4 colTablet--12">
            <Select name="experience" value={{label: this.props.filter.experience.label, id: this.props.filter.experience.id}} options={experience.sort((a, b) => {return a.order - b.order})} placeholder="Любой опыт" type="experience" changeOption={this.props.handleChange} />
          </div>
        </div>
        <div className="row">
          <div className="col col--8 colTablet--12">
            {
              this.props.scope_activity &&
              this.props.scope_activity.map((activity, index) => (
                activity.id === this.props.filter.scope_activity.id &&
                <p className="text text--bottom30 text--lh24" key={`activity_content-${index}`}>{activity.content}</p>
              ))
            }
            <VacanciesList cols={12} vacancies={this.props.vacancies} />
            {
              this.props.vacancies.next &&
              <Button text="Показать больше" submit={true} modifier="button--xs button--marginBottom" onClick={() => this.props.actions.loadVacancies(this.props.filter, false)} />
            }
            <BannersList count={1} />
          </div>
          <div className="col col--4 colTablet--12">
            <div id="toSubscribe" className="text text--h3">Подписка на вакансии</div>
            <p className="text">
              <Link scroll={scrollFunction} to="/#toResumeForm">Отправьте нам резюме</Link>
              , новые позиции откроются позже. Или оформите подписку на&nbsp;вакансии
              {
                this.props.baseCity.baseCityName &&
                <React.Fragment>
                  <span className="text text--lateral">в&nbsp;городе</span>
                  <strong>
                    {this.props.baseCity.baseCityName}
                  </strong>
                </React.Fragment>
              }
              {
                (this.props.filter.scope_activity.label && this.props.filter.scope_activity.id) &&
                <React.Fragment>
                  <span className="text text--lateral">в&nbsp;сфере деятельности</span>
                  <strong>
                    «{this.props.filter.scope_activity.label}»
                  </strong>
                </React.Fragment>
              }
              .
            </p>
            <FormSubscribe apiUrl='/vacancy/vacancy-subscriber/' city={this.props.baseCity} activity={this.props.filter.scope_activity} />
            <BannersList vertical />
          </div>
        </div>
      </div>
    );
  }

  componentWillUnmount() {
    this.props.handleOut(this.props.baseCity.baseCityID);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      this.props.actions.loadVacancies(nextProps.filter, true);
      this.props.actions.loadScopeActivity(nextProps.filter);
      this.props.actions.loadEmployments(nextProps.filter);
      this.props.actions.loadExperience(nextProps.filter);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    vacancies: state.vacancies,
    employments: state.employments.list,
    scope_activity: state.scope_activity.list,
    experience: state.experience.list,
    filter: state.filter,
    baseCity: state.baseCity,
    cities: state.cities.list
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadVacancies, loadScopeActivity, loadEmployments, loadExperience, loadCities }, dispatch),
    handleLoad: (val, label, type, content, labelPrepositional) => {
      dispatch(setFilterData(val, label, type, content))
      if (type === 'city') {
        dispatch(setCity(label))
        if (labelPrepositional) {
          dispatch(setCityPrepositional(labelPrepositional))
        } else {
          dispatch(setCityPrepositional(label))
        }
        dispatch(setCityID(val))
        dispatch(setCitySelected(true))
      }
    },
    handleChange: (val, label, type, content) => {
      dispatch(setFilterData(val, label, type, content))
    },
    handleOut: (baseCityID) => {
      dispatch(setFilterData(baseCityID, '', 'city'))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageVacancies));



// WEBPACK FOOTER //
// ./src/pages/PageVacancies/index.js